import React from 'react';
import dayjs from 'dayjs';
import { Trans } from '@lingui/macro';

/**
 * Validates the `recurrence` sub-form when `repeat` is enabled. Returns a
 * field→message map (matching `recurrence.*` field names) or `undefined` when
 * there's nothing to flag. Shared by the create and update task forms.
 *
 * @param {object} values full form values (`repeat`, `recurrence`, `dueDate`)
 */
export function validateRecurrence(values) {
  if (!values || !values.repeat) return undefined;

  const r = values.recurrence || {};
  const errors = {};

  if (!r.interval || Number(r.interval) < 1) {
    errors.interval = <Trans>Must be at least 1</Trans>;
  }

  if (r.frequency === 'weekly' && (!r.weeklyDays || !r.weeklyDays.length)) {
    errors.weeklyDays = <Trans>Select at least one day</Trans>;
  }

  if (r.frequency === 'monthly' && r.monthlyMode === 'day_of_month') {
    const day = Number(r.monthlyDay);
    if (!day || day < 1 || day > 31) {
      errors.monthlyDay = <Trans>Enter a day between 1 and 31</Trans>;
    }
  }

  if (r.endType === 'on_date') {
    if (!r.endDate) {
      errors.endDate = <Trans>This is required field</Trans>;
    } else if (
      values.dueDate &&
      dayjs(r.endDate).isBefore(dayjs(values.dueDate), 'day')
    ) {
      errors.endDate = <Trans>End date should be after due date</Trans>;
    }
  }

  if (
    r.endType === 'after_occurrences' &&
    (!r.occurrences || Number(r.occurrences) < 1)
  ) {
    errors.occurrences = <Trans>Must be at least 1</Trans>;
  }

  return Object.keys(errors).length ? errors : undefined;
}
